import tuneInRequest from '../tuneInRequest';
export default function browseService(config, apiContext, applyReauth) {
    const endpoint = `${config.domains.api}/categories/`;
    function getItems(guideId, params) {
        return tuneInRequest({
            method: 'get',
            url: `${endpoint}${guideId}`,
            params,
        }, apiContext);
    }
    function getItemsWithContext(guideId, contextGuideId, params) {
        return tuneInRequest({
            method: 'get',
            url: `${endpoint}${guideId}/${contextGuideId}`,
            params,
        }, apiContext);
    }
    return {
        getItems: applyReauth(getItems),
        getItemsWithContext: applyReauth(getItemsWithContext),
    };
}
